const GetEndPoints = (servico: string = ""): String => {
  let url: String = "";

  switch (servico.toUpperCase()) {
    case "PORTAL": {
      url = process.env.REACT_APP_API_URL_PORTAL!
      break;
    }
    case "PLANEJAMENTO": {
      url = process.env.REACT_APP_API_URL_PLANEJAMENTO!
      break;
    }
    case "PEDIDOS": {
      url = process.env.REACT_APP_API_URL_PEDIDOS!
      break;
    }
    case "PRODUCAO": {
      url = process.env.REACT_APP_API_URL_PRODUCAO!
      break;
    }
    case "ENTREGA": {
      url = process.env.REACT_APP_API_URL_ENTREGA!
      break;
    }
    case "SAP": {
      url = process.env.REACT_APP_API_URL_SAP!
      break;
    }
    case "DASHBOARD": {
      url = process.env.REACT_APP_API_URL_DASHBOARD!
      break;
    }
    default: {
      url = process.env.REACT_APP_API_URL_PORTAL!
      break;
    }
  }
  return url;
};
export default GetEndPoints;
